import React from "react";
import styles from "./horizontal-separator.module.scss";

interface HorizontalSeparatorPropTypes {
  verticalMargin?: number;
}
const className = "horizontal-separator";

export const HorizontalSeparator = ({
  verticalMargin = 8,
}: HorizontalSeparatorPropTypes) => {
  const styleVars = {
    "--vertical-margin": `${verticalMargin}px`,
  } as React.CSSProperties;
  return (
    <span
      className={styles[className]}
      style={styleVars}
      role="presentation"
      aria-hidden="true"
    />
  );
};
